export const cleanStrings = (arr = []) => arr.map((s) => s?.trim()).filter(Boolean);

const isBlank = (v) => v === null || v === undefined || v === "";

export const MIN_IMAGES = 5;

export const validateBasicInfo = (form, pendingImageFiles = []) => {
  const errors = {};
  if (!form.title?.trim()) errors.title = "Title is required";
  if (!form.location?.name?.trim()) errors.locationName = "Destination is required";
  const imageCount = cleanStrings(form.imageUrls).length + pendingImageFiles.length;
  if (imageCount < MIN_IMAGES) {
    errors.imageUrls = `Add at least ${MIN_IMAGES} images (${imageCount}/${MIN_IMAGES})`;
  }
  if (!cleanStrings(form.tags).length) errors.tags = "Add at least one tag";
  return errors;
};

export const validateDetails = (form) => {
  const errors = {};
  const inclusions =
    form.listType === "QUICK_TRIP"
      ? cleanStrings(form.inclusionsQuickTrip)
      : (form.inclusionsPackage || []).filter((i) => i.label?.trim());
  if (!inclusions.length) errors.inclusions = "Add at least one inclusion";
  return errors;
};

// keyed by entry.key -> { source?, name?, price? }
export const validateComponents = (entries) => {
  const errors = {};
  entries.forEach((entry) => {
    const rowErrors = {};
    if (entry.mode === "existing" && !entry.customization_option_id) {
      rowErrors.source = "Select a catalog option";
    }
    if (entry.mode === "new" && !entry.newName?.trim()) {
      rowErrors.name = "Name is required";
    }
    if (isBlank(entry.price_delta)) {
      rowErrors.price = "Price is required";
    }
    if (Object.keys(rowErrors).length) errors[entry.key] = rowErrors;
  });
  return errors;
};

export const validatePricing = (form) => {
  const errors = {};
  if (isBlank(form.price.amount)) errors.priceAmount = "Price amount is required";
  if (!form.startDate) errors.startDate = "Start date is required";
  if (!form.endDate) errors.endDate = "End date is required";

  if (form.listType === "QUICK_TRIP") {
    if (isBlank(form.duration)) errors.duration = "Duration is required";
    if (isBlank(form.groupSize)) errors.groupSize = "Group size is required";
  } else {
    if (isBlank(form.occupancy.travellers_per_room)) errors.travellersPerRoom = "Required";
    if (isBlank(form.occupancy.max_travellers_per_booking)) errors.maxTravellers = "Required";
  }
  return errors;
};

export const stepHasErrors = (errors) => Object.keys(errors || {}).length > 0;
